import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-blend-type-self",
  "use": "icon-blend-type-self-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" id=\"icon-blend-type-self\"><path d=\"M7.3 3.1C4.8 3.4 3 5.5 3 8s1.8 4.6 4.3 4.9zm1.5 0V13c2.4-.4 4.2-2.5 4.2-5s-1.8-4.6-4.2-4.9\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol